// Buscas recentes do visitante: só no navegador dele (localStorage), nunca
// enviadas ao servidor. Tudo protegido por try/catch: navegação privada ou
// armazenamento bloqueado simplesmente não mostra recentes.

const STORAGE_KEY = "persi:buscas-recentes";
const MAX_RECENT = 5;

export function readRecentSearches(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed)
      ? parsed.filter((item): item is string => typeof item === "string" && item.trim().length > 0).slice(0, MAX_RECENT)
      : [];
  } catch {
    return [];
  }
}

export function saveRecentSearch(term: string): string[] {
  const clean = term.trim().slice(0, 100);
  if (clean.length < 2) return readRecentSearches();
  const key = clean.toLocaleLowerCase("pt-BR");
  const next = [clean, ...readRecentSearches().filter((item) => item.toLocaleLowerCase("pt-BR") !== key)].slice(0, MAX_RECENT);
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // sem armazenamento: segue sem recentes
  }
  return next;
}
